var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingTransactionSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7302_1125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0078 44.001C26.6348 44.0044 29.2365 43.4886 31.6634 42.4833C34.0904 41.478 36.2948 40.003 38.1498 38.143C40.0098 36.2879 41.4848 34.0836 42.4901 31.6566C43.4955 29.2296 44.0112 26.6279 44.0078 24.001C44.0112 21.3741 43.4954 18.7724 42.4901 16.3454C41.4848 13.9185 40.0098 11.7141 38.1498 9.85899C36.2948 7.99902 34.0904 6.52399 31.6634 5.51868C29.2365 4.51337 26.6348 3.99759 24.0078 4.00099C21.3809 3.99764 18.7792 4.51345 16.3523 5.51876C13.9253 6.52407 11.7209 7.99906 9.86583 9.85899C8.0059 11.7141 6.5309 13.9185 5.52559 16.3454C4.52028 18.7724 4.00448 21.3741 4.00783 24.001C4.00443 26.6279 4.5202 29.2296 5.52551 31.6566C6.53083 34.0836 8.00586 36.2879 9.86583 38.143C11.7209 40.0029 13.9253 41.4779 16.3523 42.4832C18.7792 43.4885 21.3809 44.0043 24.0078 44.001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 24.001L22.0078 30.001L34.0078 18.001",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7302_1125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 0H48.0059V48H0.00585938V0Z",
    fill: "#09D0A8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingTransactionSuccess);
export default __webpack_public_path__ + "static/media/trading_transaction_success.b5e387483211f0a1b3112bfd1f21714d.svg";
export { ForwardRef as ReactComponent };